import { providers } from '../../providers';
import type { TersaImageModel } from '../types';
import { grsai } from '../grsai';
import { kie } from '../kie';

// 系数
const COST_FACTOR = 1.5;

// 计费
const GPT_IMAGE2_TOKENS_BY_RESOLUTION: Record<string, number> = { '1K': 1010, '2K': 3223, '4K': 5930 };
const gptImage2WrappedCost = ({ providerOptions }: { providerOptions?: Record<string, any> } = {}) => {
    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
    const tokens = GPT_IMAGE2_TOKENS_BY_RESOLUTION[resolution] ?? GPT_IMAGE2_TOKENS_BY_RESOLUTION['4K'];
    return 30 / (1000000 / tokens) * COST_FACTOR;
};
const gptImage2WrappedPassCount = (args: { providerOptions?: Record<string, any> } = {}) =>
    gptImage2WrappedCost(args) * 100;

export const miscModels: Record<string, TersaImageModel> = {
    'image-upscale': {
        chef: providers.flowmuse,
        hideInstructions: true,
        tags: ['image-upscale'],
        providers: [
            {
                ...providers.openai,
                model: kie.image('gpt-image-2-upscale'),
                modelBackup: [grsai.image('gpt-image-2-upscale')],
                getCost: gptImage2WrappedCost,
                getPassCount: gptImage2WrappedPassCount,
            },
        ],
        configByMode: {
            i2i: {
                sizes: [],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: false,
                },
            },
        },
        precheckByMode: {
            i2i: ['image'],
        },
        imagesCountOptions: [1],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'image-reframe': {
        chef: providers.flowmuse,
        hideInstructions: true,
        tags: ['image-reframe'],
        providers: [
            {
                ...providers.openai,
                model: kie.image('gpt-image-2-reframe'),
                modelBackup: [grsai.image('gpt-image-2-reframe')],
                getCost: gptImage2WrappedCost,
                getPassCount: gptImage2WrappedPassCount,
            },
        ],
        configByMode: {
            i2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: false,
                },
            },
        },
        precheckByMode: {
            i2i: ['image'],
        },
        imagesCountOptions: [1],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'image-repaint': {
        chef: providers.flowmuse,
        tags: ['image-inpaint'],
        providers: [
            {
                ...providers.openai,
                model: kie.image('gpt-image-2-repaint'),
                modelBackup: [grsai.image('gpt-image-2-repaint')],
                getCost: gptImage2WrappedCost,
                getPassCount: gptImage2WrappedPassCount,
            },
        ],
        configByMode: {
            i2i: {
                sizes: [],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: false,
                },
            },
        },
        precheckByMode: {
            i2i: ['image', 'prompt'],
        },
        imagesCountOptions: [1],
        supportsInput: ['i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};